


























































































import { getEmployeeList, startOrStopEmployee } from '@/api/employee'
export default {
  data() {
    return {
      name: '', // 员工姓名
      page: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      total: 0, // 总条数
      records: [], // 分页数据
    }
  },
  created() {
    this.pageQuery()
  },
  methods: {
    // 分页查询
    pageQuery() {
      // 封装参数
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.name,
      }
      // 发送ajax请求,访问后端服务，获取分页数据
      getEmployeeList(params)
        .then((res) => {
          if (res.data.code === 1) {
            this.total = res.data.data.total
            this.records = res.data.data.records
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了,' + err.message)
        })
    },
    // pageSize改变时触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageQuery()
    },
    // currentPage改变时触发
    handleCurrentChange(page) {
      this.page = page
      this.pageQuery()
    },
    // 启用/禁用员工
    handleStartOrStop(row) {
      // 判断是否为管理员
      // if (row.username === 'admin') {
      //   this.$message.error('管理员不能被禁用')
      //   return
      // }
      // 弹出确认提示框
      this.$confirm('确认更改该员工状态?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          id: row.id,
          status: row.status === 0 ? 1 : 0,
        }
        startOrStopEmployee(params).then((res) => {
          if (res.data.code === 1) {
            this.$message.success('操作成功')
            this.pageQuery()
          }
        })
      })
    },
    // 新增员工
    handleAddEmp() {
      // 跳转到新增员工页面
      this.$router.push('/employee/add')
    },

    // 编辑员工
    handleEditEmp(row) {
      // 跳转到编辑员工页面
      this.$router.push({
        path: '/employee/add',
        query: {
          id: row.id,
        },
      })
    },
  },
}
